import { MerchantNotificationsEventNamesType } from 'config/requests/merchants';
import { MerchantNotification } from 'types/embedded/merchantNotification';

export const getMerchantNotificationFormValues = (
  record: MerchantNotification,
  eventNames?: MerchantNotificationsEventNamesType[],
) => ({
  ...record,
  provider: record?.provider?.['@id'] || null,
  chatId: record?.credentials?.chatId?.toString() || null,
  comment: record?.comment || null,
  event: Object.fromEntries(
    (eventNames || []).map(({ name }) => [
      name,
      !!record?.events?.find((event) => event.name.value.toLocaleUpperCase() === name),
    ]),
  ),
});
